import EmpPage from '../components/EmployeePage'

const Employee = () => {
  return (
    <>
    <EmpPage />
    </>
  )
}

export default Employee